export default __webpack_public_path__ + "static/media/screenshot_step0_1_purple.32e35df1.png";